import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';

// Явный импорт всех CSS модулей стандартных тем для предотвращения tree-shaking в production
// Это гарантирует, что все стандартные темы будут включены в финальный bundle
// Премиум темы используют свои собственные CSS модули в layouts/
import '@/themes/standard/classic.module.css';
import '@/themes/standard/modern.module.css';
import '@/themes/standard/romantic.module.css';
import '@/themes/standard/vintage.module.css';
import '@/themes/standard/minimal.module.css';
import '@/themes/standard/garden.module.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
